import React from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';
import {
  Button,
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
  Icon,
  InfoWorkZero,
} from '@mesh.ai/rabbit';
import { openPanel } from 'components/RabbitInitiativeCreationPanel/InitiativeCreationPanelSlice';
import { closeSecondaryPanel } from 'components/RabbitInitiativeSidePanel/initiativeSecondaryPanelSlice';
import { addWeeks, setDay } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { sendOpenedInitiativePanel } from 'constants/mixpanelHelper';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

type IntelligentNudgeProps = {
  header: string;
  explanation: string;
  initiativeTitle: string;
  buttonText: string;
};

const IntelligentNudge = ({ header, explanation, initiativeTitle, buttonText }: IntelligentNudgeProps) => {
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);
  const dispatch = useDispatch();

  const handleAddInitiative = () => {
    const updatedToIds = [
      {
        uuid: loggedInEmployee.id,
        ownerType: 'OWNER',
        metadata: { displayName: loggedInEmployee.displayName },
        profile: { profilePhoto: loggedInEmployee.profilePhotoSrc },
      },
    ];

    // @ts-expect-error ts issue
    dispatch(closeSecondaryPanel());

    // set end of next week as due date
    const today = new Date();
    const nextWeek = addWeeks(today, 1);
    const nextWeekFriday = setDay(nextWeek, 5, { weekStartsOn: 0 });

    sendOpenedInitiativePanel({
      eventProperties: {
        page: 'Home',
        initiativeType: 'NUDGE_TASK',
      },
    });

    dispatch(
      openPanel({
        toIds: updatedToIds,
        text: initiativeTitle,
        taskType: 'NUDGE_TASK',
        dueTS: nextWeekFriday.valueOf(),
        page: 'Home',
        source: 'OVERVIEW_EXPLANATION',
      })
    );
  };

  return (
    <Flex flexDir="column">
      <TextBodyMedium>{header}</TextBodyMedium>
      <Flex alignItems="flex-start" justifyContent="space-between">
        <HoverCard>
          <HoverCardTrigger style={{ flex: 1 }}>
            <Flex w="full" gap="0.25rem" alignItems="center">
              <Icon aria-hidden size="small" className="text-body-secondary" IconSVG={InfoWorkZero} />
              <Text
                as="span"
                w="full"
                lineHeight="1rem"
                fontSize="0.75rem"
                whiteSpace="normal"
                color="#666"
                noOfLines={1}
              >
                {explanation}
              </Text>
            </Flex>
          </HoverCardTrigger>
          <HoverCardPortal>
            <HoverCardContent side="top">
              <Box maxW="600px">
                <Flex w="full" gap="0.25rem" alignItems="center" flex="1">
                  <Icon aria-hidden size="small" className="text-body-secondary" IconSVG={InfoWorkZero} />
                  <Text as="span" w="full" lineHeight="1rem" fontSize="0.75rem" whiteSpace="normal" color="#666">
                    {explanation}
                  </Text>
                </Flex>
              </Box>
            </HoverCardContent>
          </HoverCardPortal>
        </HoverCard>
        <Button variant="outline" onClick={handleAddInitiative}>
          {buttonText}
        </Button>
      </Flex>
    </Flex>
  );
};

export { IntelligentNudge };
